namespace Solovis.Reports.Parameters.PropValueIncludes {


    export class PropValueToIncludeControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private _resourceOptions: PropValueToIncludeResourceOption[];
        private _dateOptions: PropValueToIncludeDateOption[];

        private _propValueToInclude: PropValueToInclude;
        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        private _propDefs: InvData.Models.IdAndCodeObjectIndex<InvData.PropertyDefinition>;
        private _codeToResourceOptionMap = {};

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._resourceOptions = options.resourceOptions;
            this._dateOptions = options.dateOptions;
            this._propValueToInclude = options.propValueToInclude;
            this._propDefs = options.propDefs;
            this._codeToResourceOptionMap = options.codeToResourceOptionMap;
        }

        public doRender() {
            let propValueToInclude = this._propValueToInclude ? this._propValueToInclude : {};

            let formBuilderDiv = $("<div>").appendTo(this.container);
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                labelColumnWidth: 100,
                width: 350,
                portalServices: this._portalServices
            });

            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "propDef",
                label: "Property",

                initialValue: propValueToInclude.propDefId ? { id: propValueToInclude.propDefId } : null,

                editor: {
                    type: "parameter",
                    parameterOptions: {
                      parameterType: "property",
                      settings: {
                        filter: { hideForPropertyValuesToIncludeActive: true },
                        showIncludeHiddenItemsRow : true
                      }                   
                  }                  
                },
                postSetup: (formEntry) => {
                  const resourceRefEntry = this._formBuilder.getEntryByName("resourceRef");

                  const updateResourceRef = () => {                    
                    if (resourceRefEntry) {
                      this._updateResourceRefEditor(resourceRefEntry);
                    }
                  };
                  $(formEntry).on("valueChanged", () => {
                    updateResourceRef();
                  });
                }
            });

            let resourceOptionList = [];
            for (let resourceOption of this._resourceOptions) {
                resourceOptionList.push({
                    text: resourceOption.label,
                    value: resourceOption.code
                });
            }

            formBuilder.addEntry({
                name: "resourceRef",
                label: "For",

                initialValue: propValueToInclude.resourceRef ? propValueToInclude.resourceRef : resourceOptionList[0].value,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: resourceOptionList
                    }
                }
            });

            formBuilder.addEntry({
                name: "indirectRef",
                label: "Other Property",

                help: "Only EntityRef, ContactRef, InvestmentRef, and TransactionRef properties are supported for indirect property loads.",                   

                initialValue: propValueToInclude.indirectRef,

                applyStandardTextAlignTopPadding: true,

                createEditor: (entryOptions) => {
                    let editorDiv = $("<div>").appendTo(entryOptions.container);
                    let editorLabel = $("<span>").appendTo(editorDiv);

                    let editLink = $("<a>").appendTo(editorDiv);
                    editLink.css("padding-left", "5px");
                    $("<span class='fa fa-pencil'>").appendTo(editLink);

                    editLink.click(() => {
                        editor.showEditor();
                    });

                    let updateEditorDiv = () => {
                        let descriptionText = PropValuesToIncludeSetEditorDialog.getPropValueToIncludeLabel(editor.value, this._propDefs, this._codeToResourceOptionMap);
                        editorLabel.text(descriptionText);
                    };

                    let editor: any = {
                        value: entryOptions.initialValue,

                        getValue: () => {
                            return editor.value;
                        },

                        showEditor: () => {
                            PropValueToIncludeControl.showEditDialog(
                                {
                                    resourceOptions: this._resourceOptions,
                                    dateOptions: this._dateOptions,
                                    propValueToInclude: editor.value,
                                    propDefs: this._propDefs,
                                    codeToResourceOptionMap: this._codeToResourceOptionMap,
                                    portalServices: this._portalServices
                                },
                                (newPropValueToInclude) => {
                                    editor.value = newPropValueToInclude;
                                    updateEditorDiv();
                                });
                        }
                    };

                    updateEditorDiv();

                    return editor;
                },

                isVisible: (formEntry) => {
                    let resourceRef = formEntry.formBuilder.getValueByName("resourceRef");
                    if (resourceRef === "indirect") {
                        return true;
                    }

                    return false;
                }
            });

            if (this._dateOptions) {
                let dateOptionList = [];
                for (let dateOption of this._dateOptions) {
                    dateOptionList.push({
                        text: dateOption.label,
                        value: dateOption.code
                    });
                }

                formBuilder.addEntry({
                    name: "dateRef",
                    label: "At",

                    initialValue: propValueToInclude.dateRef ? propValueToInclude.dateRef : dateOptionList[0].value,

                    editor: {
                        type: "select",
                        selectOptions: {
                            data: dateOptionList
                        }
                    }
                });
            }

            formBuilder.addEntry({
                name: "dateMode",
                label: "Date Mode",

                initialValue: !!propValueToInclude.exactDayOnly ? "ExactDayOnly" : "LatestValue",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: [
                            { text: "Exact Day Only", value: "ExactDayOnly" },
                            { text: "Latest Value", value: "LatestValue" }
                        ]
                    }
                }
            });

            formBuilder.setupDone();
        }

        public _updateResourceRefEditor(editor): void {
          const propDefValue = this._formBuilder.getValueByName("propDef");
          const propLocationId = propDefValue ? propDefValue.defaultPropertyLocationId : null;

          // Define the mapping from `propDef` values to `resourceRef` codes
          const propDefToResourceRefMap = {
            0: "investmentHoldingOrEntity",         // Not Set
            1: "investment",                        // Investment
            2: "investmentHoldingOrEntity",         // Investment/Holding or Entity
            3: "investmentHoldingOwnerOrEntity",    // Investment/Holding/Owner or Entity
            4: "entityOrHolding",                   // Entity/Holding
            5: "owner",                             // Owner
            6: "trueOwner",                         // True Owner
            7: "manager"                            // Manager
          }; 

          const selectedResourceCode = propDefToResourceRefMap[propLocationId] || "investmentHoldingOrEntity";
          
          let selectedResourceOptionCode = null;
          for (let resourceOption of this._resourceOptions) {
            if (resourceOption.code === selectedResourceCode) {
              selectedResourceOptionCode = resourceOption.code;
              break;
            }
          }

          if (selectedResourceOptionCode && editor.entryEditor && typeof editor.entryEditor.setValue === 'function') {
            editor.entryEditor.setValue(selectedResourceOptionCode);
          }
        }


        public setWidth(newWidth) {
            if (this._formBuilder) {
                this._formBuilder.setWidth(newWidth);
            }
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }

        public getPropValueToInclude() {
            let propValueToInclude: PropValueToInclude = {};

            propValueToInclude.resourceRef = this._formBuilder.getValueByName("resourceRef");
            if (propValueToInclude.resourceRef === "indirect") {
                propValueToInclude.indirectRef = this._formBuilder.getValueByName("indirectRef");
            }

            if (this._dateOptions) {
                propValueToInclude.dateRef = this._formBuilder.getValueByName("dateRef");
            }

            let propDef = this._formBuilder.getValueByName("propDef");
            if (propDef) {
                propValueToInclude.propDefId = propDef.id;
            }

            let dateMode = this._formBuilder.getValueByName("dateMode");
            if (dateMode === "ExactDayOnly") {
                propValueToInclude.exactDayOnly = true;
            }

            return propValueToInclude;
      }

        public static showEditDialog(propValueToIncludeControlOptions, saveCallback) {
            let self = this;

            let editorDiv = $("<div>");

            let controlOptionsToUse: any = propValueToIncludeControlOptions;
            controlOptionsToUse.controlHost = editorDiv;

            let propValueToIncludeControl = new PropValueToIncludeControl(controlOptionsToUse);
            propValueToIncludeControl.setAsCurrentControl();

            let desiredWidth = Math.min($(window).width() * 0.9, 650);
            let desiredHeight = Math.min($(window).height() * 0.9, 300);

            let dialog = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "Edit Property Value To Include",
                width: desiredWidth,
                height: desiredHeight,
                modal: true,
                center: true,
                autoOpen: true,
                actions: ["Close"],
                destroyOnClose: true,

                buttons: [
                    {
                        label: "OK",
                        click: function () {
                            if (propValueToIncludeControl.isValid()) {
                                saveCallback(propValueToIncludeControl.getPropValueToInclude());
                                dialog.close();
                            }
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            dialog.close();
                        }
                    }
                ],

                contentWidthSizer: {
                    setWidth: function (newWidth) {
                        propValueToIncludeControl.setWidth(newWidth);
                    }
                }
            });
        }
    }


}